import React from "react";
import { ProgressBar } from "react-bootstrap";

const HomeSkills = () => {
    return (
        <div
            className="container-fluid text-dark"
            style={{ backgroundColor: "#c8d6e5" }}
        >
            <div className="py-4">
                <h2 className=" fw-bolder border-bottom border-3 border-success d-inline">
                    What I Know?
                </h2>
            </div>
            <div className="container">
                <div className="row g-4">
                    <div className="col-sm-12 col-md-6">
                        <h4 className="fw-bolder text-primary mb-3">
                            Front-End Skills
                        </h4>
                        <div className="container">
                            <ProgressBar
                                className="my-5"
                                now="90"
                                label="HTML"
                                variant="success"
                            />
                            <ProgressBar
                                className="my-5"
                                now="92"
                                label="CSS"
                                variant="Primary"
                            />
                            <ProgressBar
                                className="my-5"
                                now="70"
                                label="CSS Frameworks"
                                variant="secondary"
                            />
                            <ProgressBar
                                className="my-5"
                                now="75"
                                label="React JS"
                                variant="info"
                            />
                            <ProgressBar
                                className="my-5"
                                now="70"
                                label="Firebase"
                                variant="warning"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 mb-3">
                        <h4 className="fw-bolder text-primary">
                            Back-End Skills
                        </h4>
                        <div className="container">
                            <ProgressBar
                                className="my-5"
                                now="70"
                                label="Npm"
                                variant="secondary"
                            />
                            <ProgressBar
                                className="my-5"
                                now="70"
                                label="Node JS"
                                variant="danger"
                            />
                            <ProgressBar
                                className="my-5"
                                now="85"
                                label="Express JS"
                                variant="Info"
                            />
                            <ProgressBar
                                className="my-5"
                                now="90"
                                label="Mongo DB"
                                variant="success"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeSkills;
